import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AsvConsultationRequestLineModel } from '../../../../../models/aggregates/asv/asv-consultation-request-line.model';
import {BaseApiTemplateService, Core2Config} from '../../api-services';

@Injectable({
  providedIn: 'root'
})
export class AsvConsultationRequestLineService extends BaseApiTemplateService<AsvConsultationRequestLineModel> {

    readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX +
    Core2Config.ASV_PREFIX + 'consultation-request-lines';

    constructor(http: HttpClient) {
        super();
        this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ASV_PREFIX + 'consultation-request-lines/' + Core2Config.BACKOFFICE_EP_SUFFIX; 
        this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ASV_PREFIX + 'consultation-request-lines/' + Core2Config.BACKOFFICE_EP_SUFFIX;
        this.httpClient = http;
      }
}
